export class Config {
	public  _apiSite = "https://programme.worldwaterweek.org/";
	public  _apiSiteWordpress = "https://admin.worldwaterweek.org/wp-json/siwiWP/v1/";
	public  _apiEndpoint = "https://programme.worldwaterweek.org/API/";
	public  _appVersion = "Version 12.8.24 Build 20241208";
	public  _appName = "";
	public  _appTitle = "Siwi World Waterweek";
}
